function n(n){var r=n.condition,t=n.wrap,a=n.children;return r?t(a):a}export{n as default};
//# sourceMappingURL=ct-design-conditional-wrapper.browser.esm.js.map
